<!-- <h3 class="store-title">{{ 'HOURS_OF_OPERATION.TITLE' | translate }}</h3> -->
<ng-content select="[title]"></ng-content>
<table>
  @for(segment of _store()?.hoursOfOperation; track $index) {
  <tr>
    <th>{{ 'WEEKDAY.'+segment.name | uppercase | translate }}</th>
    <td>
      @if(segment.open == null || segment.close == null) {
      {{ 'WEEKDAY.CLOSED' | translate }}
      } @else {
      {{ segment.open }} - {{ segment.close }}
      }
    </td>
  </tr>
  }
</table>
<ng-content></ng-content>
